<template>
<div class="recent-user-cloud" v-loading="loading">
  <div class="cloud-box">
    <div class="earth-box">
      <big-word-cloud-chart :recent-user-data="recentUserData"></big-word-cloud-chart>
    </div>
  </div>
  <y-spacer>
    <y-block-box title="用户单位">
      <template #suffix>
        <router-link to="/board">
          <i title="返回数据看板" class="el-icon-back y-icon-btn"></i>
        </router-link>
      </template>
      <el-table v-loading="loading" style="height: max-content;min-height: 100%;" :data="recentUserData">
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="name" label="用户名" align="center"></el-table-column>
        <el-table-column prop="value" label="数量" align="center"></el-table-column>
      </el-table>
    </y-block-box>
  </y-spacer>
</div>
</template>

<script>
import BigWordCloudChart from "@/pages/RecentUserCloud/components/BigWordCloudChart.vue";

export default {
  name: "RecentUserCloud",
  components: {BigWordCloudChart},
  data(){
    return{
      loading:false,
      recentUserData:[]
    }
  },
  mounted() {
    this.initData()
  },
  methods:{
    async initData() {
      this.loading = true
      const res = await this.$callApi("board.getTeamCount");
      this.recentUserData = res.data || []
      this.loading = false
    }
  }
}
</script>

<style lang="less" scoped>
.recent-user-cloud{
  display: flex;
  height: 100%;
}
.cloud-box{
  width: 60%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  &:before{
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
    height: 100%;
    aspect-ratio: 1;
    background-image: url("./image/地球.png");
    background-size: 100% 100%;
    //background-color: rgba(255,255,255,0.3);
    border-radius: 2000px;
    padding: 20px;
    opacity: 0.5;
    //box-shadow: 2px 2px 4px 1px #9aa3b4;
  }
}
.earth-box{
  height: 100%;
  width: 100%;
  //aspect-ratio: 1;
  //background-image: url("./image/地球.png");
  //background-size: 100% 100%;
  //background-color: rgba(255,255,255,0.3);
  //border-radius: 2000px;
  //padding: 20px;
  //box-shadow: 2px 2px 4px 1px #9aa3b4;
}
</style>



// WEBPACK FOOTER //
// src/pages/RecentUserCloud/RecentUserCloud.vue